import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import JobCreateActionButton from '../../Jobs/JobCreateActionButton';

export default GaleraDisableSSLButton;

export type GaleraDisableSSLButtonProps = ButtonProps & {
    cluster: CcCluster;
    onSuccess?: () => void;
};

function GaleraDisableSSLButton({
    cluster,
    onSuccess,
    ...rest
}: GaleraDisableSSLButtonProps) {
    return (
        <JobCreateActionButton
            clusterId={cluster.clusterId}
            command={
                CmonJobInstanceCommand.ENCRYPT_REPLICATION.toLowerCase() as CmonJobInstanceCommand
            }
            jobData={{
                action: 'disable',
                clusterId: `${cluster.clusterId}`,
                certificateId: `${cluster?.primaryNode?.sslCerts?.server?.id}`,
            }}
            confirmTitle={
                'Are you sure you want to disable Galera SSL encryption?'
            }
            title={'Galera SSL encryption'}
            okText="Disable"
            onSuccess={onSuccess}
            switchValue={true}
            {...rest}
        />
    );
}
